import { useStores } from '@littlebird/sdk';
import { useMemo } from 'react';

import { useHiddenProactiveAgentChatIds } from '@/features/settings/proactive-agent.query';

/**
 * The chats that chat lists leave out: proactive agent chats this device hides, and chats Littlebird started from
 * to-dos that the user has not written in yet. Read it in an `observer`, so the list updates when the user writes
 */
export const useChatListHiddenChatIds = (): ReadonlySet<string> => {
  const agentChatIds = useHiddenProactiveAgentChatIds();
  const todoChatIds = useStores().actionCards.autoStartedChatIds;
  return useMemo(
    () => new Set([...agentChatIds, ...todoChatIds]),
    [agentChatIds, todoChatIds]
  );
};
